import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledInfoCard = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${(p) => p.theme.spacing(1)};
  gap: ${(p) => p.theme.spacing(1)};
  background: ${(p) => p.theme.palette.grey[200]};
  border-radius: ${(p) => p.theme.spacing(1)};
`;
